import React from 'react'

import { F0Icon } from '@factorialco/f0-react'
import { Tooltip } from '@factorialco/f0-react/dist/experimental'
import { InfoCircleLine } from '@factorialco/f0-react/icons/app'

import { SummaryContext } from './SummaryContext'
import { SelectionManager } from './useSelectionManager'

type Props = {
  title: string
  dateRange: string
  totalHours: string
  dotColor: string
  selectable: boolean
  children: React.ReactNode
  selectionManager?: SelectionManager
  tooltip?: {
    label: string
    description: string
  }
}

const SummaryCard = ({
  title,
  dateRange,
  totalHours,
  dotColor,
  selectable,
  children,
  selectionManager,
  tooltip,
}: Props) => {
  return (
    <SummaryContext.Provider value={{ selectable, selectionManager }}>
      <div className="bg-white rounded-xl shadow-sm ">
        {/* Card Header */}
        <div className="flex justify-between items-center px-3 gap-2">
          <div className="flex items-center gap-1 min-w-0 flex-1">
            <span
              className="w-2.5 h-2.5 rounded-full flex-shrink-0"
              style={{ backgroundColor: dotColor }}
            ></span>
            <h2 className="text-base font-semibold truncate">{title}</h2>
            <span className="text-base flex-shrink-0 whitespace-nowrap">· {dateRange}</span>
            {tooltip && (
              <div className="flex-shrink-0">
                <Tooltip label={tooltip.label} description={tooltip.description}>
                  <F0Icon icon={InfoCircleLine} size="sm" color="secondary" />
                </Tooltip>
              </div>
            )}
          </div>
          <div className="w-18 text-right font-semibold flex-shrink-0">{totalHours}</div>
        </div>

        {/* Card Body */}
        <div className="mt-4 flex flex-col gap-3">{children}</div>
      </div>
    </SummaryContext.Provider>
  )
}

export default SummaryCard
